<template>
  <section>
    <div class="container">
      <el-scrollbar style="height: 100%">
        <div class="dnr" style="width:320px">
          <div class="title">
              <div><i class="el-icon-date"></i>&nbsp;&nbsp;答题卡</div>
             <span class="allscore-text" v-if="paperList !== ''">总分：{{allScore.toFixed(2)}}</span>
          </div>
          <!-- <div class="leftdiv" v-if="paperList !== ''">
            <span class="allscore-text" v-if="paperList !== ''">总分：{{allScore.toFixed(2)}}</span>
          </div> -->
          <div class="nr" v-if="dxt != 0">
            <span style="padding-left: 22px">单选题</span>
            <span style="padding-left: 10px">(共{{ dxt }}题，合计{{ dxtSum.toFixed(2) }}分)</span>
          </div>
          <div class="leftdiv" v-if="dxt != 0">
            <div style="display: flex; flex-wrap: wrap">
              <div
                v-for="(item, index1) in paperList"
                :key="index1+'g'"
                @click="jump2(item.id)"
                v-if="item.type == 1"
              >
                <div
                  v-if="tijiao"
                  :class="[item.MyCate?(item.IsRight == true ? 'rightcolor' : 'errcolor'):'top']"
                  @click="btnOption(index1)"
                >
                  <span style=" font-size: 14px; color: white;">{{ index1 + 1 }}</span>
                </div>
                <div
                  v-else
                  :class="[item.MyCate == true ? 'aaa' : 'top']"
                  @click="btnOption(index1)"
                >
                  <span style="font-size: 14px; color: white">{{ index1 + 1 }}</span>
                </div>
                <!-- <div class="bottom">
                  <svg
                    v-if="item.bjStatus == true"
                    class="icon"
                    style="margin-left: 5px"
                  >
                    <use xlink:href="#iconbiaoji"></use>
                  </svg>
                </div>-->
<!--                <div class="bottom">-->
<!--                  <i v-if="item.bjStatus == true" class="iconfont icon-qizi-copy"></i>-->
<!--                </div>-->
              </div>
            </div>
          </div>
          <div class="nr" v-if="ddxt != 0">
            <span style="padding-left: 22px">多选题</span>
            <span style="padding-left: 10px">(共{{ ddxt }}题，合计{{ ddxtSum.toFixed(2) }}分)</span>
          </div>
          <div class="leftdiv" v-if="ddxt != 0">
            <div style="display: flex; flex-wrap: wrap">
              <div
                v-for="(item, index2) in paperList"
                :key="index2 +'f'"
                @click="jump2(item.id)"
                v-if="item.type == 2"
              >
                <div
                  v-if="tijiao"
                  :class="[item.MyCate?(item.IsRight == true ? 'rightcolor' : 'errcolor'):'top']"
                  @click="btnOption(index2)"
                >
                  <span style=" font-size: 14px; color: white">{{ index2 + 1 }}</span>
                </div>
                <div
                  v-else
                  :class="[item.MyCate == true ? 'aaa' : 'top']"
                  @click="btnOption(index2)"
                >
                  <span style=" font-size: 14px; color: white">{{ index2 + 1 }}</span>
                </div>
<!--                <div class="bottom">-->
<!--                  <i v-if="item.bjStatus == true" class="iconfont icon-qizi-copy"></i>-->
<!--                </div>-->
              </div>
            </div>
          </div>
          <div class="nr" v-if="pdt != 0">
            <span style="padding-left: 22px">判断题</span>
            <span style="padding-left: 10px">(共{{ pdt }}题，合计{{ pdtSum.toFixed(2) }}分)</span>
          </div>
          <div class="leftdiv" v-if="pdt != 0">
            <div style="display: flex; flex-wrap: wrap">
              <div
                v-for="(item, index3) in paperList"
                :key="index3 +'d'"
                v-if="item.type == 3"
                @click="jump2(item.id)"
              >
                <div
                  v-if="tijiao"
                 :class="[item.MyCate?(item.IsRight == true ? 'rightcolor' : 'errcolor'):'top']"
                  @click="btnOption(index3)"
                >
                  <span style=" font-size: 14px; color: white">{{ index3 + 1 }}</span>
                </div>
                <div
                  v-else
                  :class="[item.MyCate == true ? 'aaa' : 'top']"
                  @click="btnOption(index3)"
                >
                  <span style=" font-size: 14px; color: white">{{ index3 + 1 }}</span>
                </div>
<!--                <div class="bottom">-->
<!--                  <i v-if="item.bjStatus == true" class="iconfont icon-qizi-copy"></i>-->
<!--                </div>-->
              </div>
            </div>
          </div>
          <div class="nr" v-if="tkt != 0">
            <span style="padding-left: 22px">填空题</span>
            <span style="padding-left: 10px">(共{{ tkt }}题，合计{{ tktSum.toFixed(2) }}分)</span>
          </div>
          <div class="leftdiv" v-if="tkt != 0">
            <div style="display: flex; flex-wrap: wrap">
              <div
                v-for="(item, index5) in paperList"
                :key="index5+'c'"
                @click="jump2(item.id)"
                v-if="item.type == 4"
              >
                <div
                  v-if="tijiao"
                  :class="[item.MyCate?(item.IsRight == true ? 'rightcolor' : 'errcolor'):'top']"
                  @click="btnOption(index5)"
                >
                  <span style=" font-size: 14px; color: white">{{ index5 + 1 }}</span>
                </div>
                <div
                  v-else
                  :class="[item.MyCate == true ? 'aaa' : 'top']"
                  @click="btnOption(index5)"
                >
                  <span style=" font-size: 14px; color: white">{{ index5 + 1 }}</span>
                </div>
<!--                <div class="bottom">-->
<!--                  <i v-if="item.bjStatus == true" class="iconfont icon-qizi-copy"></i>-->
<!--                </div>-->
              </div>
            </div>
          </div>
          <div class="nr" v-if="wdt != 0">
            <span style="padding-left: 22px">问答题</span>
            <span style="padding-left: 10px">(共{{ wdt }}题，合计{{ wdtSum.toFixed(2) }}分)</span>
          </div>
          <div class="leftdiv" v-if="wdt != 0">
            <div style="display: flex; flex-wrap: wrap">
              <div
                v-for="(item, index4) in paperList"
                :key="index4+'b'"
                @click="jump(item.id)"
                v-if="item.type == 5"
              >
                <div
                  v-if="tijiao"
                  :class="[item.MyCate?(item.IsRight == true ? 'rightcolor' : 'errcolor'):'top']"
                  @click="btnOption(index4)"
                >
                  <span style=" font-size: 14px; color: white">{{ index4 + 1 }}</span>
                </div>
                <div
                  v-else
                  :class="[item.MyCate == true ? 'aaa' : 'top']"
                  @click="btnOption(index4)"
                >
                  <span style=" font-size: 14px; color: white">{{ index4 + 1 }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="nr" v-if="sct!= 0">
            <span style="padding-left: 22px">实操题</span>
            <span style="padding-left: 10px">(共{{ sct }}题，合计{{ sctSum.toFixed(2) }}分)</span>
          </div>
          <div class="leftdiv" v-if="sct!= 0">
            <div style="display: flex; flex-wrap: wrap">
              <div
                v-for="(item, index6) in paperList"
                :key="index6+'a'"
                @click="jump(item.id)"
                v-if="item.type == 6"
              >
                <div
                  v-if="tijiao"
                  :class="[item.MyCate?(item.IsRight == true ? 'rightcolor' : 'errcolor'):'top']"
                  @click="btnOption(index6)"
                >
                  <span style=" font-size: 14px; color: white">{{ index6 + 1 }}</span>
                </div>
                <div
                  v-else
                  :class="[item.MyCate == true ? 'aaa' : 'top']"
                  @click="btnOption(index6)"
                >
                  <span style=" font-size: 14px; color: white">{{ index6 + 1 }}</span>
                </div>
                <div class="bottom">
                  <i v-if="item.bjStatus == true" class="iconfont icon-qizi-copy"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-scrollbar>
    </div>
  </section>
</template>

<script>
import { SelectPaperQuestion } from '@/api/exam/paper';
export default {
  props:['questionList'],
  data() {
    return {
      paperList: [],
      dxt: 0,
      dxtSum: 0,
      dxt: 0,
      dxtSum: 0,
      tkt: 0,
      tktSum: 0,
      pdt: 0,
      pdtSum: 0,
      wdt: 0,
      wdtSum: 0,
      ddxt: 0,
      ddxtSum: 0,
      sct: 0,
      sctSum: 0,
      Ids: localStorage.getItem('Id'),
      paperId: localStorage.getItem('paperId'),
      trainId: localStorage.getItem('trainId'),
      // list: sessionStorage.getItem('list'),
      tijiao: sessionStorage.getItem('tijiao'),
      allScore: 0,
      questionLists:null,

    };
  },
  methods: {
    jump(domId) {
      // 当前窗口正中心位置到指定dom位置的距离
      //页面滚动了的距离
      let height =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      //指定dom到页面顶端的距离
      let dom = document.getElementById(domId);
      let domHeight = dom.offsetTop;
      //滚动距离计算
      var S = Number(height) - Number(domHeight);
      //判断上滚还是下滚
      if (S < 0) {
        //下滚
        S = Math.abs(S);
        window.scrollBy({ top: S, behavior: 'smooth' });
      } else if (S == 0) {
        //不滚
        window.scrollBy({ top: 0, behavior: 'smooth' });
      } else {
        //上滚
        S = -S;
        window.scrollBy({ top: S, behavior: 'smooth' });
      }
    },
    jump2(domId) {
      document.getElementById(domId).scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    },
    Selected(index, indexs, item) {
      if (item.MyCate == true) {
        this.paperList[index].MyCate = true;
      } else {
        this.paperList[index].MyCate = false;
      }
    },
    //传给父级的数据
    btnOption(index) {
      this.$emit('btnLeft', index);
    },
    bj(item, index) {
      if (item.bjStatus == true) {
        this.paperList[index].bjStatus = true;
      } else {
        this.paperList[index].bjStatus = false;
      }
    },
    getList() {
      let para = {
        pagerId: this.paperId,
        examId: this.Ids,
      };
      this.questionLists.forEach(item => {
          item.bjStatus = false;
          // item.MyCate = false;
          item.value = '';
          item.CheckAnswer = [];
          if (item.type == 1) {
            this.dxt += 1;
            this.dxtSum += item.score;
          } else if (item.type == 2) {
            this.ddxt += 1;
            this.ddxtSum += item.score;
          } else if (item.type == 3) {
            this.pdt += 1;
            this.pdtSum += item.score;
          } else if (item.type == 5) {
            this.wdt += 1;
            this.wdtSum += item.score;
          } else if (item.type == 4) {
            this.tkt += 1;
            this.tktSum += item.score;
          } else if (item.type == 6) {
            this.sct += 1;
            this.sctSum += item.score;
          }
      });
      this.allScore = Number(
            this.dxtSum +
            this.ddxtSum +
            this.pdtSum +
            this.wdtSum +
            this.tktSum +
            this.sctSum
        );
        this.paperList = this.questionLists

      // SelectPaperQuestion(para).then((res) => {
      //   for (let i = 0; i < res.data.length; i++) {
      //     res.data[i].answer = JSON.parse(res.data[i].answer);
      //     res.data[i].bjStatus = false;
      //     res.data[i].MyCate = false;
      //     res.data[i].value = '';
      //     res.data[i].CheckAnswer = [];
      //     if (res.data[i].type == 1) {
      //       this.dxt += 1;
      //       this.dxtSum += res.data[i].score;
      //     } else if (res.data[i].type == 2) {
      //       this.ddxt += 1;
      //       this.ddxtSum += res.data[i].score;
      //     } else if (res.data[i].type == 3) {
      //       this.pdt += 1;
      //       this.pdtSum += res.data[i].score;
      //     } else if (res.data[i].type == 5) {
      //       this.wdt += 1;
      //       this.wdtSum += res.data[i].score;
      //     } else if (res.data[i].type == 4) {
      //       this.tkt += 1;
      //       this.tktSum += res.data[i].score;
      //     } else if (res.data[i].type == 6) {
      //       this.sct += 1;
      //       this.sctSum += res.data[i].score;
      //     }
      //   }
      //   if (sessionStorage.getItem('list')) {
      //     this.paperList = JSON.parse(sessionStorage.getItem('list'));
      //   } else {
      //     this.paperList = res.data;
      //   }
      //   this.allScore = Number(
      //     this.dxtSum +
      //       this.ddxtSum +
      //       this.pdtSum +
      //       this.wdtSum +
      //       this.tktSum +
      //       this.sctSum
      //   );
      // });

    },
    tj() {
      this.$parent.Submit();
    },
  },
  created() {
    
    this.questionLists=this.questionList
    this.questionLists=JSON.parse(this.questionLists)
    this.getList();
    this.tijiao = sessionStorage.getItem('tijiao');
  },
};
</script>

<style scoped>
@import url('../../../assets/font_81dv624ewpl/iconfont.css');
.aaa {
  height: 20px;
  min-width: 35px;
  margin-left: 5px;
  margin-top: 15px;
  border-radius: 2px;
  background-color: #1a8cfe;
  text-align: center;
}
.container {
  /* height: 600px; */
  /* width: 100%; */
  border: 1px solid #f2f2f2;
  border-radius: 5px;
  background-color: white;
}
.title {
  font-size: 17px;
  padding: 15px 20px 15px 20px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
}
.nr {
  font-size: 10px;
  padding-top: 20px;
  padding-left: 8px;
}
.top {
  height: 20px;
  min-width: 35px;
  margin-left: 5px;
  margin-top: 15px;
  background-color: gray;
  border-radius: 2px;
  text-align: center;
}
.bottom {
  height: 20px;
  min-width: 35px;
  text-align: center;
  margin-left: 5px;
  margin-bottom: 5px;
  background-color: #f1f3f8;
  border-radius: 2px;
  /* margin-right: 15px; */
}
.el-scrollbar__wrap {
  overflow-x: hidden;
}
.icon {
  width: 1em;
  height: 1em;
  font-size: 15px;
}
.icons {
  width: 1em;
  height: 1em;
  font-size: 15px;
}
.leftdiv {
  width: 280px;
  border-bottom: 1px solid rgb(226, 223, 223);
  /* padding-left: 25px; */
  margin: 0 auto;
}
.table {
  margin-left: 20px;
  margin-top: 10px;
}
table {
  border: 1px solid #f2f2f2;
}
th {
  border: 1px solid #f2f2f2;
  width: 55px;
  line-height: 30px;
  font-size: 15px;
}
.a {
  font-size: 13px;
  font-weight: 100;
  background: #f2f2f2;
}
.rightcolor {
  height: 20px;
  min-width: 35px;
  margin-left: 5px;
  margin-top: 15px;
  border-radius: 2px;
  background-color: green;
  text-align: center;
}
.errcolor {
  height: 20px;
  min-width: 35px;
  margin-left: 5px;
  margin-top: 15px;
  background-color: red;
  border-radius: 2px;
  text-align: center;
}
.iconfont {
  font-size: 12px;
  color: #409eff;
}
.allscore-text {
  /* margin-left: 120px; */
  font-size: 18px;
  font-weight: 600;
  /* padding: 20px; */
}
</style>